"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeLayer2 = _interopRequireDefault(require("./CreativeLayer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GroupCreativeLayer = /*#__PURE__*/function (_CreativeLayer) {
  (0, _inherits2["default"])(GroupCreativeLayer, _CreativeLayer);

  var _super = _createSuper(GroupCreativeLayer);

  /**
   * Child layers
   */
  function GroupCreativeLayer(element, content) {
    var _this;

    (0, _classCallCheck2["default"])(this, GroupCreativeLayer);
    _this = _super.call(this, element, content); // regenerate Creative Layer's id

    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_children", new Set());
    _this._id = "c".concat(_this.contentId);
    return _this;
  }

  (0, _createClass2["default"])(GroupCreativeLayer, [{
    key: "removeChildLayer",
    value: function removeChildLayer(childLayer) {
      if (!this.children.has(childLayer)) return;
      this.children.remove(childLayer);
    }
    /**
     * Checks if object is an instance of GroupCreativeLayer
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "children",
    get: function get() {
      return this._children;
    },
    set: function set(value) {
      this._children = value;
    }
  }, {
    key: "loaded",
    get: function get() {
      return true;
    }
  }], [{
    key: "isGroupCreativeLayer",
    value: function isGroupCreativeLayer(inputObject) {
      return inputObject instanceof GroupCreativeLayer;
    }
  }]);
  return GroupCreativeLayer;
}(_CreativeLayer2["default"]);

exports["default"] = GroupCreativeLayer;